var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResponsive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 501.551 501.551",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M484.833,41.796H20.898C9.404,41.796,0,51.2,0,62.694v321.829h501.551V58.514 C501.551,49.11,494.237,41.796,484.833,41.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M0,384.522v39.706c0,11.494,9.404,20.898,20.898,20.898h459.755c11.494,0,20.898-9.404,20.898-20.898 v-39.706H0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CDD6E0"
    },
    cx: 250.776,
    cy: 414.824,
    r: 11.494
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.645,
    y: 445.126,
    style: {
      fill: "#CDD6E0"
    },
    width: 192.261,
    height: 39.706
  })), /*#__PURE__*/React.createElement("rect", {
    x: 113.894,
    y: 484.833,
    style: {
      fill: "#F2F2F2"
    },
    width: 272.718,
    height: 16.718
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.645,
    y: 445.126,
    style: {
      fill: "#ACB3BA"
    },
    width: 192.261,
    height: 15.673
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.437,
    y: 72.098,
    style: {
      fill: "#84DBFF"
    },
    width: 434.678,
    height: 282.122
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#334A5E"
    },
    points: "330.188,72.098 330.188,41.796 330.188,41.796 345.861,41.796 345.861,72.098  345.861,72.098  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#334A5E"
    },
    points: "155.69,72.098 155.69,41.796 155.69,41.796 171.363,41.796 171.363,72.098 171.363,72.098  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M317.649,0H183.902c-7.314,0-12.539,5.224-12.539,12.539v238.237c0,7.314,5.225,12.539,12.539,12.539 h133.747c7.314,0,12.539-5.224,12.539-12.539V12.539C330.188,5.224,324.963,0,317.649,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.051,
    y: 25.161,
    style: {
      fill: "#FFFFFF"
    },
    width: 131.657,
    height: 201.665
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ACB3BA"
    },
    cx: 250.776,
    cy: 244.506,
    r: 10.449
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M268.539,9.404h-35.527c-2.09,0-3.135,1.045-3.135,3.135l0,0c0,2.09,1.045,3.135,3.135,3.135h35.527 c2.09,0,3.135-1.045,3.135-3.135l0,0C271.673,10.449,270.629,9.404,268.539,9.404z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 195.396,
    y: 40.751,
    style: {
      fill: "#FFD15C"
    },
    width: 52.245,
    height: 52.245
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.91,
    y: 40.751,
    style: {
      fill: "#FFD15C"
    },
    width: 52.245,
    height: 52.245
  })), /*#__PURE__*/React.createElement("rect", {
    x: 195.396,
    y: 99.265,
    style: {
      fill: "#FF7058"
    },
    width: 110.759,
    height: 43.886
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 195.396,
    y: 153.6,
    style: {
      fill: "#CDD6E0"
    },
    width: 110.759,
    height: 24.033
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.396,
    y: 191.216,
    style: {
      fill: "#CDD6E0"
    },
    width: 110.759,
    height: 24.033
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsive);
export default __webpack_public_path__ + "static/media/responsive.fb2df58f9854d54f999b4825faba16ca.svg";
export { ForwardRef as ReactComponent };